module.exports = __webpack_public_path__ + "img/p-two-step-16.4d74e08e.png";